import React, { FC } from "react";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { makeStyles } from "@material-ui/core";
import { muiStylesValidationState } from "./muiStylesValidationState";

const useStyles = makeStyles(muiStylesValidationState);

const ValidationState: FC<{ error: boolean }> = ({ error }) => {
  const classes = useStyles();

  return (
    <>
      {error ? (
        <CancelIcon className={`${classes.icons} ${classes.error}`} />
      ) : (
        <CheckCircleIcon className={`${classes.icons} ${classes.success}`} />
      )}
    </>
  );
};

export default ValidationState;
